import { redirectToLoginPage, redirectToLogoutPage, } from '@ovh-ux/manager-core-sso';
export function auth(params = {}) {
    const goToLogin = params.goToLogin || redirectToLoginPage;
    const goToLogout = params.goToLogout || redirectToLogoutPage;
    return {
        login: goToLogin,
        logout: goToLogout,
    };
}
export function clientAuth(shellClient) {
    return {
        login: () => shellClient.invokePluginMethod({
            plugin: 'auth',
            method: 'login',
            args: [],
        }),
        logout: (url) => shellClient.invokePluginMethod({
            plugin: 'auth',
            method: 'logout',
            args: [url],
        }),
    };
}
export default auth;
//# sourceMappingURL=index.js.map